<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              md="12"
            >
              <v-form
                ref="form_all"
                v-model="valid.all"
              >
                <v-tabs
                  v-model="tab"
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Учетная запись
                  </v-tab>
                  <v-tab v-if="!profile">
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Лояльность
                  </v-tab>
                  <v-tab v-if="!profile">
                    <v-icon left>
                      mdi-domain
                    </v-icon>Организации
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-lock
                    </v-icon>Смена пароля
                  </v-tab>

                  <v-tab-item>
                    <v-row
                      dense
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        class="mt-5 text-body-1"
                        md="6"
                      >
                        Учетная запись
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.phone"
                          outlined
                          label="Номер мобильного телефона"
                          :prepend-icon="icon"
                          :counter="10"
                          :maxlength="10"
                          :rules="[(v) => (/9\d{9}/.test(v) || v.length == 0) || 'Номер телефона должен быть в формате +79XXXXXXXXX']"
                          prefix="+7"
                          :readonly="$route.path.startsWith('/common')"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.email"
                          outlined
                          label="Email"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        class="mt-5 text-body-1"
                        md="6"
                      >
                        Персональные данные
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.surname"
                          outlined
                          label="Фамилия"
                          :rules="validations.rules.required"
                          :readonly="$route.path.startsWith('/common')"
                        />
                        <v-text-field
                          v-model="form.name"
                          outlined
                          label="Имя"
                          :rules="validations.rules.required"
                          :readonly="$route.path.startsWith('/common')"
                        />
                        <v-text-field
                          v-model="form.patronymic"
                          outlined
                          label="Отчество"
                          :readonly="$route.path.startsWith('/common')"
                        />
                        <v-text-field
                          v-model="form.birthday"
                          outlined
                          label="Дата рождения"
                          type="date"
                          :max="max_date"
                          :rules="validations.rules.max_date"
                          :readonly="$route.path.startsWith('/common')"
                        />
                        <!--<v-text-field
                                                    outlined
                                                    label="ИНН"
                                                    v-model="form.inn"
                                                    :rules="[(v) => check_doc('inn', v) || 'Неверное значение']"
                                                    :counter="12"
                                                    maxlength="12"
                                                />-->
                        <v-switch
                          v-model="form.deleted"
                          label="Активен"
                          :false-value="true"
                          :true-value="false"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="!profile">
                    <user-profile-form v-model="attrSaved" />
                  </v-tab-item>
                  <v-tab-item v-if="!profile">
                    <v-row
                      v-for="(org, index) in form.organizations"
                      :key="'org_' + index"
                      class="mt-5 justify-center"
                      dense
                    >
                      <v-col
                        cols="10"
                        md="5"
                      >
                        <v-autocomplete
                          v-if="org.role!=1"
                          v-model="org.client"
                          outlined
                          label="Организация"
                          :items="select.clients"
                          item-value="id"
                          item-text="legal.name.short"
                          :rules=" validations.rules.required"
                        />
                        <v-text-field
                          v-if="org.role!=1"
                          v-model="org.department"
                          outlined
                          label="Подразделение"
                        />
                        <v-text-field
                          v-if="org.role!=1"
                          v-model="org.post"
                          outlined
                          label="Должность"
                        />

                        <v-text-field
                          v-if="org.role!=1"
                          v-model="org.pernum"
                          outlined
                          label="Табельный номер"
                          counter="32"
                          maxlength="32"
                        />
                        <v-select
                          v-model="org.role"
                          outlined
                          label="Системная роль"
                          :items="select.role"
                          :rules="validations.rules.required"
                          :item-text="org.custom_role?'text2':'text'"
                        />
                        <v-select
                          v-if="org.role!=1"
                          v-model="org.custom_role"
                          outlined
                          label="Роль сотрудника"
                          :items="select.custom_roles"
                          item-value="id"
                          item-text="name"
                          clearable
                        />
                      </v-col>
                      <v-col
                        cols="2"
                        md="1"
                      >
                        <v-icon
                          large
                          @click="form.organizations = form.organizations.filter(a=>a!=org)"
                        >
                          mdi-minus-circle-outline
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="form.organizations.length == 0 || form.organizations[0].role!=1"
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        class="text-left"
                        md="6"
                      >
                        <v-btn
                          text
                          color="primary"
                          @click="form.organizations.push({role: 2})"
                        >
                          <v-icon
                            large
                            class="mr-2"
                            color="primary"
                          >
                            mdi-plus-circle-outline
                          </v-icon>
                          Добавить организацию
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row
                      v-if="profile"
                      dense
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        class="mt-5 text-body-1"
                        md="6"
                      >
                        Смена пароля
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="profile"
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.password"
                          outlined
                          label="Текущий пароль"
                          type="password"
                          :rules="[(v) => !form.newpassword || !!v || 'Обязательно для заполнения']"
                        />
                        <v-text-field
                          v-model="form.newpassword"
                          outlined
                          label="Новый пароль"
                          :type="password.show1?'text':'password'"
                          :append-icon="password.show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="password.show1=!password.show1"
                        />
                        <v-text-field
                          v-model="form.newpassword2"
                          outlined
                          label="Повторите пароль"
                          :rules="[(v) => (form.newpassword == form.newpassword2) || 'Неверное значение']"
                          :type="password.show2?'text':'password'"
                          :append-icon="password.show2 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="password.show2=!password.show2"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="!profile"
                      dense
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        class="mt-5 text-body-1"
                        md="6"
                      >
                        Смена пароля
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="!profile"
                      dense
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.newpassword"
                          outlined
                          label="Новый пароль"
                          :type="password.show1?'text':'password'"
                          :append-icon="password.show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="password.show1=!password.show1"
                        />
                        <v-text-field
                          v-model="form.newpassword2"
                          outlined
                          label="Повторите пароль"
                          :rules="[(v) => (form.newpassword == form.newpassword2) || 'Неверное значение']"
                          :type="password.show2?'text':'password'"
                          :append-icon="password.show2 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="password.show2=!password.show2"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              md="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Отмена</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              md="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                :disabled="!valid.all"
                @click="save"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import UserProfileForm from "@/views/loyalty/components/user_profile/UserProfileForm"
  import { createParticipant } from "@/views/loyalty/shared/modules/create_participant"
  export default {
    components: { UserProfileForm, },
    props: ['tab', 'profile'],
    data: () => ({
        validations: {
            valid: {
            form: false
            },
            rules: {
            required: [
                value => !!value || value === false || 'Обязательное поле.'
            ],
            required_date: [
                value => !!value || value === false || 'Обязательное поле.',
                value => moment(value) <= moment() || 'Некорректная дата'
            ],
            max_date: [
                value => !value || moment(value) <= moment() || 'Некорректная дата'
            ],
            name_rules: [
                value => !!value || 'Обязательное поле.',
                value => (value || '').length >= 2 || 'Минимум 2 символа',
                value => (value || '').length <= 25 || 'Максимум 25 символа',
                value => {
                const pattern = /^[a-zA-Zа-яА-ЯёЁ\-]+$/
                return pattern.test(value) || 'Недопустимые символы'
                }
            ],
            email_rules: [
                value => !!value || 'Обязательное поле',
                value => (value || '').length <= 30 || 'Максимум 30 символов',
                value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Недопустимая почта'
                },
            ]
        }
      },
        valid: {
            all: false
        },
      profile: false,
      password: {
          show1: false,
          show2: false
      },
      form: {
          phone: '',
          organizations: [],
          password: '',
          newpassword: '',
          newpassword2: ''
      },
      select: {
          custom_roles: [],
          role: [],
          clients: [],
          services: []
      },
      attrSaved: false
    }),
    computed: {
        max_date: function () {
            return moment().format('YYYY-MM-DD')
        },
    },
    mounted: function () {
      var id = this.$route.query.id
      if (!id && this.$route.path.indexOf('profile') > -1) {
        id = this.$store.state.user.id // если query не задан, то это профиль
        this.profile = true
      }
      if (id) { this.load(id) }
      this.load_clients()
      // this.load_services()
      this.load_roles()
      if (this.$store.state.user.current_client) {
          this.select.role = [
              {
                  value: 2, text: 'Клиентский администратор', text2: 'Сотрудник'
              }
          ]
      } else {
          this.select.role = [
              {
                  value: 1, text: 'Администратор'
              },
              {
                  value: 2, text: 'Клиентский администратор', text2: 'Сотрудник'
              },
              {
                  value: 3, text: 'Физ.лицо'
              }
          ]
      }
    },
    methods: {
        load_roles: function () {
            this.axios.post('/api/role/list', { })
            .then(response => {
                if (!response.data.error) {
                    this.select.custom_roles = response.data.data
                } else {

                }
            })
            .catch(e => {
                console.log(e)
            })
        },
        save_account: function (item) {
            this.axios.post('/api/account/save', item).then(response => {
                if (!response.data.error) {
                    this.$store.commit('snackbar', 'Успешно')
                    var id = this.$route.query.id
                    if (!id && this.$route.path.indexOf('profile') > -1) {
                        id = this.$store.state.user.id // если query не задан, то это профиль
                        this.profile = true
                    }
                    if (id) { this.load(id) }
                } else {
                    this.$store.commit('snackbar', response.data.data)
                }
            }).catch(e => {
                console.log(e)
                this.$store.commit('snackbar', e)
            })
        },
        account_change: function (id, change) {
            const account = this.form.accounts.filter(a => a.id == id)[0]
            const index = this.form.accounts.indexOf(account)
            console.log(account)
            account.change = change
            window.Vue.set(this.form.accounts, index, account)
        },
        get_accounts: function (id) {
            var services = this.select.services.filter(a => a.client == id)
            const accounts = []
            for (const x in services) {
                const service = services[x]
                for (const y in this.form.accounts) {
                    const account = this.form.accounts[y]
                    if (account.service == service.id) {
                        accounts.push(account)
                    }
                }
            }
            console.log(accounts)
            return accounts
        },
        validateInn: function (inn, error) {
        var result = false
        if (typeof inn === 'number') {
          inn = inn.toString()
        } else if (typeof inn !== 'string') {
          inn = ''
        }
        if (!inn.length) {
            return true
        } else if (/[^0-9]/.test(inn)) {
          error.code = 2
          error.message = 'ИНН может состоять только из цифр'
        } else if ([10, 12].indexOf(inn.length) === -1) {
          error.code = 3
          error.message = 'ИНН может состоять только из 10 или 12 цифр'
        } else {
          var checkDigit = function (inn, coefficients) {
            var n = 0
            for (var i in coefficients) {
              n += coefficients[i] * inn[i]
            }
            return parseInt(n % 11 % 10)
          }
          switch (inn.length) {
            case 10:
              var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8])
              if (n10 === parseInt(inn[9])) {
                result = true
              }
              break
            case 12:
              var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
                result = true
              }
              break
          }
          if (!result) {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      check_doc: function (type, number) {
        if (type == 'inn') {
          const error = {}
          if (this.validateInn(number, error)) return true
          else return error.message
        }
        if (type == 'snils') {
          const error = {}
          if (this.validateSnils(number, error)) return true
          else return error.message
        }
        return true
      },
      validateSnils (snils, error) {
        var result = false
        if (typeof snils === 'number') {
          snils = snils.toString()
        } else if (typeof snils !== 'string') {
          snils = ''
        }
        if (!snils.length) {
          error.code = 1
          error.message = 'СНИЛС обязателен лля заполнения'
        } else if (/[^0-9]/.test(snils)) {
          error.code = 2
          error.message = 'СНИЛС может состоять только из цифр'
        } else if (snils.length !== 11) {
          error.code = 3
          error.message = 'СНИЛС может состоять только из 11 цифр'
        } else {
          var sum = 0
          for (var i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i)
          }
          var checkDigit = 0
          if (sum < 100) {
            checkDigit = sum
          } else if (sum > 101) {
            checkDigit = parseInt(sum % 101)
            if (checkDigit === 100) {
              checkDigit = 0
            }
          }
          if (checkDigit === parseInt(snils.slice(-2))) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
        load_clients: function () {
            this.axios.post('/api/client/list', { state: 0 })
            .then(response => {
                if (!response.data.error) {
                    this.select.clients = response.data.data
                } else {

                }
            })
            .catch(e => {
                console.log(e)
            })
        },
        // load_services: function () {
        //     this.axios.post('/api/service/list', { state: 0 })
        //     .then(response => {
        //         if (!response.data.error) {
        //             this.select.services = response.data.data
        //         } else {
        //
        //         }
        //     })
        //     .catch(e => {
        //         console.log(e)
        //     })
        // },
      load: function (id) {
        this.axios.post('/api/user/list', { id: id })
          .then(response => {
            if (!response.data.error) {
              this.form = response.data.data[0]
              this.form.password = ''
              this.form.newpassword = ''
              this.form.newpassword2 = ''
              if (this.form.birthday) {
                  this.form.birthday = moment(this.form.birthday).format('YYYY-MM-DD')
              }
            } else {

            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      check_form: function () {
          var res = this.$refs.form_all.validate()
          if (!res) return false
          console.log('check_form', res)
          if (this.form.organizations.length == 0) {
              this.$store.commit('snackbar', 'Необходимо указать хотя бы одну организаци')
                  return false
              }
          for (const x in this.form.organizations) {
              if (!this.form.organizations[x].role || this.form.organizations[x].role == 0) {
                   this.$store.commit('snackbar', 'Необходимо указать роль пользователя')
                   return false
              }
              if (this.form.organizations[x].role != 1) {
                if (this.form.organizations[x].client) {
                    const client = this.select.clients.filter(a => a.id == this.form.organizations[x].client)[0]
                    console.log(client)
                    if (client && client.type == 2 && this.form.organizations[x].role == 3) {
                        if (!this.form.organizations[x].pernum) {
                            this.$store.commit('snackbar', 'Поле табельный номер обязательно для заполнения')
                            return false
                        }
                    }
                } else {
                    this.$store.commit('snackbar', 'Необходимо указать партнера')
                    return false
                }
              }
          }
          return true
      },
      save: function () {
          if (!this.check_form()) return
          let url = '/api/user/save'
          if (!this.form.id) {
              url = '/api/user/create'
          }
           this.axios.post(url, this.form)
          .then(response => {
            if (!response.data.error) {
              this.$router.go(-1)
              this.attrSaved = true
              // if (!this.form.id) {
              createParticipant(this.select.clients, response.data.data.id, response.data.data.number)
              // }
            } else {
              this.$store.commit('snackbar', response.data.data)
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', e)
          })
      }
    },
  }
</script>
